/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PublishingInputs */

const en_publishing = /** @type {(inputs: PublishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing...`)
};

const id_publishing = /** @type {(inputs: PublishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menerbitkan...`)
};

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const es_publishing = en_publishing;

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const fr_publishing = en_publishing;

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const de_publishing = en_publishing;

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const ja_publishing = en_publishing;

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const zh_publishing = en_publishing;

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const ar_publishing = en_publishing;

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const it_publishing = en_publishing;

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const ru_publishing = en_publishing;

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const pt_publishing = en_publishing;

/** @type {(inputs: PublishingInputs) => LocalizedString} */
const ko_publishing = en_publishing;

/**
* | output |
* | --- |
* | "Publishing..." |
*
* @param {PublishingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const publishing = /** @type {((inputs?: PublishingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PublishingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_publishing(inputs)
	if (locale === "es") return es_publishing(inputs)
	if (locale === "fr") return fr_publishing(inputs)
	if (locale === "de") return de_publishing(inputs)
	if (locale === "ja") return ja_publishing(inputs)
	if (locale === "zh") return zh_publishing(inputs)
	if (locale === "ar") return ar_publishing(inputs)
	if (locale === "id") return id_publishing(inputs)
	if (locale === "it") return it_publishing(inputs)
	if (locale === "ru") return ru_publishing(inputs)
	if (locale === "pt") return pt_publishing(inputs)
	return ko_publishing(inputs)
});